import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  title: {
    textAlign: "center",
    marginTop: theme.spacing(10),
  },
  actionButton: {
    width: "100%",
    margin: theme.spacing(6),
    background:
      "linear-gradient(90deg, rgba(144,19,254,1) 0%, rgba(83,109,254,1) 48%, rgba(255,92,147,1) 100%)",
  },
  mainBox: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));
